<template>
    <div  style="position: relative;width: 85vw;"  >
        <!-- 表格栏 -->
        <el-button @click="test1" class="greybtn s1" style="left: 188px;top:70px;position: fixed;" size="mini" type="primary" icon="el-icon-back">返回</el-button>
        <el-button @click="submitForm" class="bluebtn s1" style="right: 10px;top:70px; position: fixed;" size="mini" type="primary" >&nbsp;&nbsp;保存&nbsp;&nbsp;</el-button>
        <div  class="list">
            <h4>{{ title }}</h4>
            <div >
                <div class="font1">基础信息</div>
            <el-form style="padding-left: 40px" :model="dataForm"
                     label-width="90px"
                     :rules="dataFormRules"
                     ref="dataForm"
                     label-position="right">
                <el-form-item label="ID"
                              prop="id"
                              v-if="false">
                    <el-input  v-model.trim="dataForm.id"
                              :disabled="true"
                              auto-complete="off"></el-input>
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="7">
                        <el-form-item label="端游编码"
                                    prop="projectNo">
                            <el-input  size="small" type="text"
                                    v-model.trim="dataForm.projectNo"
                                    auto-complete="off"
                                    :disabled="true"
                                    placeholder="自动生成"
                                    ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col style="margin-left: 100px;" :span="7">
                        <el-form-item label="游戏名称"
                                    prop="name">
                            <el-input  size="small" type="text"
                                    v-model.trim="dataForm.name"
                                    auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                <el-col style="margin-left: 80px;" :span="7" >
                        <el-form-item label="状态"
                                    prop="status">
                        <el-select
                        v-model="dataForm.status"
                        value-key="status"
                        placeholder='请选择'
                        size="small"
                        style="width: 100%;"
                        >
                        <el-option 
                            v-for="item in statusObj"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item  label="游戏Logo"
                                  prop="pic">
                        <div class="main-img">
                            <el-upload
                                    ref="upload-top"
                                    v-model.trim="dataForm.pic"
                                    :action="action"
                                    :data="{dir: 'home/banner/'}"
                                    :headers="headers"
                                    list-type="picture-card"
                                    :on-remove="handleRemove"
                                    :on-success="handleSuccess"
                                    :file-list="fileList"
                                    :class="mainFlag==true?'':'hide'">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-col>
                <!-- <el-col style="margin-left: 100px;" :span="7">
                    <el-form-item  label="申请示例图"
                                  prop="honourPicExample">
                        <div class="main-img">
                            <el-upload
                                    ref="upload-top"
                                    v-model.trim="dataForm.honourPicExample"
                                    :action="action"
                                    :data="{dir: 'home/banner/'}"
                                    :headers="headers"
                                    list-type="picture-card"
                                    :on-remove="handleRemove1"
                                    :on-success="handleSuccess1"
                                    :file-list="fileList1"
                                    :class="mainFlag1==true?'':'hide'">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-col> -->
                <el-col  style="margin-left: 100px;" :span="7" >
                    <el-form-item label="服务单位"
                                    prop="unit">
                        <el-select
                            v-model="dataForm.unit"
                            value-key="unit"
                            placeholder="请输入或者选择"
                            clearable
                            filterable
                            size="small"
                            style="width: 100%;"
                            allow-create>
                            <el-option
                            v-for="(key,index) in unit"
                            :key="index"
                            :label="key"
                            :value="key"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col style="margin-left: 80px;" :span="7">
                        <el-form-item label="排序"
                                      prop="sort">
                            <el-input-number style="display: flex;" size="small" v-model.trim="dataForm.sort" ></el-input-number>
                        </el-form-item>
                </el-col>
                <el-col  style="display: flex;" >
                        <el-form-item label="图标配色"
                                      prop="sort">
                            <div class="block">
                                <el-color-picker v-model="dataForm.logoColor"></el-color-picker>
                            </div>
                        </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                <div  class="font3">示例图信息</div>
                <el-col  :span="7">
                    <el-form-item label-width="100px"  label="申请示例图"
                                  prop="honourPicExample">
                        <div class="wide-img">
                            <el-upload
                                    ref="upload-top"
                                    v-model.trim="dataForm.honourPicExample"
                                    :action="action"
                                    :data="{dir: 'home/banner/'}"
                                    :headers="headers"
                                    list-type="picture-card"
                                    :on-remove="handleRemove1"
                                    :on-success="handleSuccess1"
                                    :file-list="fileList1"
                                    :class="mainFlag1==true?'':'hide'">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col style="margin-left: 80px;"  :span="7">
                    <el-form-item label-width="120px" label="示例图要求"
                                prop="honourPicTip">
                        <el-input size="small" type="text"
                                v-model.trim="dataForm.honourPicTip"
                                auto-complete="off"></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
                </el-form>
            </div>
            <div>
            </div>
            <div class="font2">服务详情</div>
            <div  style="margin-left: 65px;  width: auto;">
            <el-table   :cell-style="{padding: '2px 0'}"    class="tagclass"  :header-cell-style="{backgroundColor:'#ccc', 'text-align':'center',color:'#555',padding:'2px 2px'}"
                    :data="dataForm.attrList"  :span-method="objectSpanMethod"   border >
                        <el-table-column    align="center"  label="使用位置" width="120" >
                            <template #default="scope">
                                {{ positionObj[scope.row.position] }}
                            </template>
                        </el-table-column>
                        <el-table-column  label="应用位置" width="200" >
                                <template #default="scope" >
                                    <el-checkbox style="margin-right: 5px;" :false-label="0" :true-label="1" v-model="scope.row.showCard" label="名片"></el-checkbox>
                                    <el-checkbox style="margin-right: 5px;" :false-label="0" :true-label="1" v-model="scope.row.showFilter" label="筛选"></el-checkbox>
                                    <el-checkbox style="margin-right: 5px;" :false-label="0" :true-label="1" v-model="scope.row.showProduct" label="产品"></el-checkbox>
                                </template>
                        </el-table-column>
                        <el-table-column  label="单选/多选" width="160" >
                                <template #default="scope">
                                    <el-radio v-model="scope.row.type" :label="0">单选</el-radio>
                                    <el-radio v-model="scope.row.type" :label="1">多选</el-radio>
                                </template>
                        </el-table-column>
                         <el-table-column  label="服务类目" width="160" >
                            <template #default="scope">
                                <div style="display: flex;">
                                    <el-input style="width: 140px;margin: 5px;" size="small"   v-model="scope.row.attributeName" ></el-input>
                                    <div style="display: flex;align-items: center;justify-content: center;">
                                        <i style="color: #67bf56;font-size: 16px;" @click="insTagObj(scope)"  class="el-icon-circle-plus"></i>
                                        <i style="color: red;font-size: 16px;padding-left: 2px;" @click="delTagObj(scope)" class="el-icon-delete"></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column  :resizable="false" label="服务详情" min-width="115" >
                            <template  #default="scope">
                                <div style="display: flex; flex-wrap: wrap;">
                                    <div v-for="(item, index) in scope.row.values"  style="display: flex;margin-bottom: 5px;">
                                        <div >
                                            <el-input 
                                                v-model="item.attributeValue" 
                                                size="small"
                                                :key="index"
                                                :style="{ width: item.width}"
                                                @input="handleInput(index,2,scope.$index)">
                                            </el-input>
                                            <span class="measure-span">{{ measureText }}</span>
                                        </div>
                                        <div style="display: flex;align-items: center;justify-content: center;">
                                            <i style="color: #67bf56;font-size: 16px;margin-left: 1px;" @click="insInput(index,2,scope.$index)"  class="el-icon-circle-plus"></i>
                                            <i style="color: red;font-size: 16px;margin-right: 5px;" @click="delInput(index,2,scope.$index)" class="el-icon-delete"></i>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
            </div>
                        <div class="font2">服务类型</div>
            <div style="margin-left: 60px;">
                <!-- <div class="scroll-container" style="margin-left: 65px;  width: auto;margin-bottom: 10px;">
                     <p style="height: 28px;background-color: #ccc;display: flex;justify-content: center;align-items: center;color: #555;font-weight: 600;font-size: 14px;" >服务类型</p>
                    <div  class="xq">
                       <div class="yl" style="margin-left: 15px;margin-right: 10px;" >娱乐开黑</div>
                        <div v-for="(item, index) in inputs"  style="display: flex;">
                            <div class="input-container">
                                <el-input 
                                    v-model="item.value" 
                                    size="small"
                                    :key="index"
                                    :style="{ width: item.width,}"
                                    clearable
                                    @input="handleInput(index,1)">
                                </el-input>
                                <span class="measure-span">{{ measureText }}</span>
                            </div>
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <i style="color: #67bf56;font-size: 16px;margin-left: 1px;" @click="insInput(index,1)"  class="el-icon-circle-plus"></i>
                                <i style="color: red;font-size: 16px;margin-right: 5px;" @click="delInput(index,1)" class="el-icon-delete"></i>
                            </div>
                        </div>
                        
                    </div>
                </div> -->
                <el-table  :cell-style="{padding: '2px 0'}"    class="tagclass"  :header-cell-style="{backgroundColor:'#ccc', 'text-align':'center',color:'#555',padding:'2px 2px'}"
                        :data="dataForm.serveTypeList"  :span-method="objectSpanMethod"   border >
                        <el-table-column    align="center"  label="服务类型" width="300" >
                            <template #default="scope">
                                <el-input class="inputCenter" size="small"  :disabled="scope.row.type == 0 ? true : false"  v-model="scope.row.name" ></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column  label="段位/等级要求" min-width="250" >
                                <template #default="scope" >
                                    <el-select class="inputCenter" size="small" style="width:100%" v-model="scope.row.projectRankAttributeValueName"  clearable>
                                    <el-option
                                            v-for="(key,index) in getList"
                                            :key="index"
                                            :label="key"
                                            :value="key">
                                    </el-option>
                                        </el-select>
                                </template>
                        </el-table-column>
                        <el-table-column  label="可定价要求说明" min-width="350" >
                                <template #default="scope">
                                <el-input class="inputCenter" size="small"    v-model="scope.row.priceRequirement" ></el-input>
                                </template>
                        </el-table-column>
                        <el-table-column  label="可设置价格区间" width="300" >
                                <template #default="scope">
                                <el-input style="width: 80px;" class="inputCenter" size="small"  placeholder="起始价"  v-model="scope.row.minPrice" ></el-input>&nbsp;&nbsp;&nbsp;&nbsp;~
                                <el-input style="width: 80px;" class="inputCenter" size="small"  placeholder="顶价"  v-model="scope.row.maxPrice" ></el-input>
                                <!-- <el-checkbox style="margin-right: 5px;" :false-label="0" :true-label="1" v-model="scope.row.showCard" label="名片"></el-checkbox> -->
                                </template>
                        </el-table-column>
                        <el-table-column  label="新客价" width="150" >
                                <template #default="scope">
                                <el-input class="inputCenter" size="small"    v-model="scope.row.newCustomerPrice" ></el-input>
                                </template>
                        </el-table-column>
                        <el-table-column  label="操作" width="150" >
                                <template #default="scope">
                                        <div style="display: flex;align-items: center;justify-content: center;">
                                            <div  class="operatorInt" @click="insObj(scope.$index)" >新增</div>
                                            <div class="operatorDel"  @click="delObj(scope.$index)" >删除</div>
                                        </div>
                                </template>
                        </el-table-column>
                    </el-table>
            </div>
            <div style="height: 200px;"></div>
        </div>
    </div>
</template>

<script>
    import Cookies from "js-cookie"
    import KtButton from "@/views/Core/KtButton"
    import { EventBus } from '@/utils/event-bus'
    
    // 阻止容器滚动事件冒泡

    
    export default {
        components: {
            KtButton,
        },

        data () {
            return {
                action: this.global.backUploadImg + '/api/common/uploadImg',
                height: 0,
                gradeData: [],
                infoObj:['多选','单选'],
                statusObj: [{
                    id: 0,
                    name: '启用'
                }, {
                    id: 1,
                    name: '禁用'
                }],
                unit:['局','次','首','10分钟','半小时','小时'],
                positionObj:['游戏信息','游戏范围','游戏擅长'],
                dataForm:{
                    category:0,
                    projectNo: '',
                    name: '',
                    sort: 0,
                    description: '',
                    honourPicExample:'',
                    pic: '',
                    unit:'',
                    creator: Cookies.get('user'),
                    serveTypeList:[],
                    attrList:[],
                    logoColor:'',
                },
                fileList: [],
                fileList1: [],
                mainFlag: true,
                mainFlag1: true,
                dataFormRules: {
                    name: [{ required: true, message: '请输入', trigger: 'blur' }, { max: 32, message: '长度限制32位', trigger: 'blur' }],
                    honourPicTip: [{ required: true, message: '请输入', trigger: 'blur' }, { max: 32, message: '长度限制32位', trigger: 'blur' }],
                    status: { required: true, message: '请选择状态', trigger: 'change' },
                    unit: { required: true, message: '请选择服务单位', trigger: 'change' },
                    pic: { required: true, message: '请上转Logo', trigger: 'change' },
                    honourPicExample: { required: true, message: '请上转示例图', trigger: 'change' },
                },
                s1:'娱乐开黑',
                title:'',

                inputs: [{value: '', 
                width: '100px' },],

                
                measureText: ''
                }
        },
        
        created () {
        
        },
        activated () {
            //绑定回车事件
            this.commonUtil.enter(this, 'searchButton')
            let params = this.$route.query
        },
        methods: {



            // 调用 其他组件方法 关闭当前标签 
            test1(){
                this.$destroy()
                // EventBus.$emit('custom-event')
                this.$router.go(-1);
                EventBus.$emit('custom-event')
            },

            submitForm() {
                this.$refs.dataForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.dataForm)
                        // let dataForm = Object.assign({}, this.dataForm);
                            this.$api.game.update(this.dataForm).then((res) => {
                                if (res.code == 200) {
                                    this.$message({ message: '添加成功', type: 'success' })
                                    this.$router.go(-1);
                                    EventBus.$emit('custom-event')
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: "error"
                                    });
                                    this.$router.go(-1);
                                    EventBus.$emit('custom-event')
                                }
                            })
                    }
                })
            },


            insInput(index,int,indexMap){
                if(int===1){
                this.dataForm.serveTypeList.splice(index+1,0,
                    {
                    name: '', 
                    width: '100px' 
                })
                }else{
                    this.dataForm.attrList[indexMap].values.splice(index+1,0,{
                    attributeValue: '', 
                    width: '100px' 
                })
                }
            },
            delInput(index,int,indexMap){
                if(int===1){
                    console.log(this.dataForm.serveTypeList.length)
                    if(this.dataForm.serveTypeList.length === 2){
                        this.$message({message: '当前数据不可少于1', type: 'error'})
                    }else{
                        this.dataForm.serveTypeList.splice(index,1)
                    }
                }else{
                    if(this.dataForm.attrList[indexMap].values.length === 1){
                        this.$message({message: '当前数据不可少于1', type: 'error'})
                    }else{
                        this.dataForm.attrList[indexMap].values.splice(index,1)
                    }
                }
            },

            handleInput(index,int,indexMap) {
                if(int === 1){
                   this.measureText = this.dataForm.serveTypeList[index].name;
                    this.$nextTick(() => {
                    const span = document.querySelector('.measure-span');
                    this.dataForm.serveTypeList[index].width = `${Math.max(span.offsetWidth, 100)}px`;
                }); 
                }else{
                    this.measureText = this.dataForm.attrList[indexMap].values[index].attributeValue
                    this.$nextTick(() => {
                    const span = document.querySelector('.measure-span');
                    this.dataForm.attrList[indexMap].values[index].width = `${Math.max(span.offsetWidth, 100)}px`;
                    });
                }
            },
                
            editInput(data){
                    for (let i = 0; i < data.length; i++) {
                    this.measureText = this.dataForm.serveTypeList[i].name;
                        this.$nextTick(() => {
                        const span = document.querySelector('.measure-span');
                        this.dataForm.serveTypeList[i].width = `${Math.max(span.offsetWidth, 100)}px`;
                     });
            }
            },

            // MountEditInput(data){
            //     if(data.length == 1){
            //         data.push({
            //             name:'',
            //         })
            //     }
            //         for (let i = 0; i < data.length; i++) {
            //         this.measureText = this.dataForm.serveTypeList[i].name;
            //             this.$nextTick(() => {
            //             const span1 = document.createElement('span');
            //             span1.style.fontSize = '14px';
            //             span1.textContent = this.dataForm.serveTypeList[i].name;
            //             document.body.appendChild(span1);
            //             const width = span1.offsetWidth;
            //             document.body.removeChild(span1);
            //             this.dataForm.serveTypeList[i].width = `${Math.max(width+18, 100)}px`; 
            //          }
            //         );
            //          }
            // },

            MountEditInput1(data) {
                const measurements = [];
                data.forEach((item, index) => {
                    item.values.forEach((val, idx) => {
                        this.measureText = this.dataForm.attrList[index].values[idx].attributeValue;
                        measurements.push({
                            rowIndex: index,
                            colIndex: idx,
                            text: this.measureText
                        });
                    });
                });
                this.$nextTick(() => {
                    const spans = document.querySelectorAll('.measure-span');
                    measurements.forEach((measurement, index) => {
                        if (spans[index]) {
                            const span1 = document.createElement('span');
                            span1.style.fontSize = '14px';
                            span1.textContent = measurement.text;
                            document.body.appendChild(span1);
                            const width1 = span1.offsetWidth;
                            document.body.removeChild(span1);
                            const width = Math.max(width1+18, 100);
                            this.$set(
                                this.dataForm.attrList[measurement.rowIndex].values[measurement.colIndex],
                                'width', 
                                `${width}px`
                            );
                        }
                    });
                });
            },
            editInput1(data) {
                const measurements = [];
                data.forEach((item, index) => {
                    item.values.forEach((val, idx) => {
                        this.measureText = this.dataForm.attrList[index].values[idx].attributeValue;
                        measurements.push({
                            rowIndex: index,
                            colIndex: idx,
                            text: this.measureText
                        });
                    });
                });
                this.$nextTick(() => {
                    const spans = document.querySelectorAll('.measure-span');
                    measurements.forEach((measurement, index) => {
                        if (spans[index]) {
                            const width = Math.max(spans[index].offsetWidth, 100);
                            this.$set(
                                this.dataForm.attrList[measurement.rowIndex].values[measurement.colIndex],
                                'width', 
                                `${width}px`
                            );
                        }
                    });
                });
            },
            
            // 删除新增数据
            delTagObj(val){
                let pos = this.dataForm.attrList.filter(item=> item.position == val.row.position).length
                if(pos >= 2){
                    this.dataForm.attrList.splice(val.$index,1) 
                }else{
                    this.$message({ message: '当前数据不可少于1', type: "error" })
                }
            },
            // 新增数据
            insTagObj(val){
                this.dataForm.attrList.splice(val.$index+1,0,{
                    position:val.row.position,
                    attributeName:'',
                    showCard:0,
                    showFilter:1,
                    showProduct:0,
                    type:0,
                    values:[{attributeValue:'',width: '120px'}],
                })
            },

            // 新增服务类型
            insObj(val){
                    this.dataForm.serveTypeList.splice(val+1,0,
                    {name:'',type:'1',priceRequirement:'',newCustomerPrice:'',maxPrice:'',minPrice:'',projectRankAttributeValueName:'',}
                    )
            },
            // 删除服务类型
            delObj(val){
                if(val){
                    this.dataForm.serveTypeList.splice(val,1) 
                }else{
                    this.$message({ message: '当前数据不可少于1', type: "error" })
                }
            },


            // 合并table 首列单元格
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                let myInt = [{
                    zongshu:0,
                    index:[]
                    },{
                    zongshu:0,
                    index:[]
                    },{
                    zongshu:0,
                    index:[]
                    }]
                this.dataForm.attrList.forEach((item,idx)=>{
                    if(item.position === 0){
                        myInt[0].zongshu = myInt[0].zongshu+1
                        myInt[0].index.push(idx)
                    }else if(item.position === 1){
                        myInt[1].zongshu = myInt[1].zongshu+1
                        myInt[1].index.push(idx)
                    }else if(item.position === 2){
                        myInt[2].zongshu = myInt[2].zongshu+1
                        myInt[2].index.push(idx)
                    }
                })
                if (columnIndex === 0) {
                    if(row.position === 0 && myInt[0].zongshu >= 2 ){
                        if(myInt[0].index[0] == rowIndex){
                            return{
                                rowspan:myInt[0].zongshu,
                                colspan:1,
                            }
                        }else{
                            return{
                                rowspan:0,
                                colspan:0,
                            }
                        }
                        
                    }else if(row.position === 1 && myInt[1].zongshu >= 2){
                        if(myInt[1].index[0] == rowIndex){
                            return{
                                rowspan:myInt[1].zongshu,
                                colspan:1,
                            }
                        }else{
                            return{
                                rowspan:0,
                                colspan:0,
                            }
                        }
                        
                    }else if(row.position === 2 && myInt[2].zongshu >= 2){
                        if(myInt[2].index[0] == rowIndex){
                            return{
                                rowspan:myInt[2].zongshu,
                                colspan:1,
                            }
                        }else{
                            return{
                                rowspan:0,
                                colspan:0,
                            }
                        }
                    }
                }},


        
        
            //图片上传：文件列表移除文件时的钩子
            handleRemove (file, fileList) {
                console.log("触发图片删除")
                this.dataForm.pic = ''
                this.mainFlag = true
            },
            //图片上传：上传成功时的钩子
            handleSuccess (response, file, fileList) {
                console.log("触发图片上传成功")
                if(response.code != 200) {
                    this.fileList = [];
                    this.$message({message: response.message, type: 'error'})
                }
                this.dataForm.pic = response.data
                this.mainFlag = false
            },
            //图片上传：文件列表移除文件时的钩子
            handleRemove1 (file, fileList) {
                console.log("触发图片删除")
                this.dataForm.honourPicExample = ''
                this.mainFlag1 = true
            },
            //图片上传：上传成功时的钩子
            handleSuccess1 (response, file, fileList) {
                console.log("触发图片上传成功")
                if(response.code != 200) {
                    this.fileList1 = [];
                    this.$message({message: response.message, type: 'error'})
                }
                this.dataForm.honourPicExample = response.data
                this.mainFlag1 = false
            },
            


        },
        mounted () {
            let data = this.$route.params.data;
            // data.serveTypeList = data.serveTypeList.map((item)=>{
            //     return{
            //         ...item,
            //         width:'100px'
            //     }
            // })
           data.attrList = data.attrList.map((val)=>{
                val.values.map((item)=>{
                    return{
                    ...item,
                    width:'100px'
                }
                })
                 
                return{
                        ...val,
                    }
            })
            this.dataForm = data
            // this.MountEditInput(this.dataForm.serveTypeList)
            if (this.dataForm.pic) {
                        this.fileList = [{name: this.dataForm.pic, url: this.dataForm.pic}]
                        this.mainFlag = false
            }
            if (this.dataForm.honourPicExample) {
                        this.fileList1 = [{name: this.dataForm.honourPicExample, url: this.dataForm.honourPicExample}]
                        this.mainFlag1 = false
            }
            this.title = this.$route.name

            setTimeout(()=>{
                this.MountEditInput1(this.dataForm.attrList)
            },)
        },
        computed: {
            headers () {
                return {
                    "Authorization": sessionStorage.getItem('token') // 直接从本地获取token就行
                }
            },
            getList (){
                let s1 = []
                this.dataForm.attrList[0].values.forEach((val)=>{
                    s1.push(val.attributeValue)
                })
                return  s1
            }
        },
    }
</script>


<style lang="scss" scoped >
    .s1{
        cursor: pointer;
        pointer-events: auto;
        z-index: 99;
        font-size: 14px;
    }


    .list{
        margin-left: 30px;
        position: relative;
        h4{
        text-align: left;
        margin-bottom: 15px;
        margin-top: 40px;
        font-size: 15px;
        }
        .font1{
            text-align: left;
            margin-left: 40px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 15px;
            font-weight: 600;
            font-size: 14px;
        }
        .font2{
            text-align: left;
            margin-left: 40px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 15px;
            font-weight: 600;
            font-size: 14px;
        }
        .font3{
            text-align: left;
            border-bottom: 1px solid #ccc;
            margin-bottom: 15px;
            font-weight: 600;
            font-size: 14px;
        }
        .scroll-container {
            width: 100%;
            overflow: hidden;
            position: relative;
            border: 1px solid #ccc;
        
                    .xq{
                        display: flex;
                        height: 60px;
                        align-items: center;
                        font-size: 14px;
                        overflow-x: auto; /* 开启横向滚动 */
                        white-space: nowrap; /* 防止子项换行，可选，如果希望子项在一行内滚动 */

            
                        .yl{
                            display: flex;
                            border-radius: 4px;
                            height: 32px;
                            background: #F5F7FA;
                            font-size: 13px;
                            color: black;
                            cursor: not-allowed;
                            padding-left: 20px;
                            padding-right: 20px;
                            align-items: center;
                            border: 1px solid #E4E7ED;
                        }

                        .measure-span {
                        position: absolute;
                        visibility: hidden;
                        white-space: pre;
                        font: inherit;
                        padding-right: 20px;
                        }
                    }
        }


        .tagclass{
            .measure-span {
                position: absolute;
                visibility: hidden;
                white-space: pre;
                font: inherit;
                padding-right: 20px;
                }
        }

    }
    .operatorInt{
        color: #fff;
        font-size: 16px;
        width: 45px;
        background-color: #67bf56;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }
    .operatorDel{
        color: #fff;
        margin-left: 10px;
        font-size: 16px;
        width: 45px;
        background-color: red;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/views/Pms/Editgame.vue